var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('full-width-image-carousel',{attrs:{"images":_vm.images,"swiper_config":_vm.swiper_config,"swiper_breakpoints":_vm.swiper_breakpoints}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }